import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckSquare, FiStar } = FiIcons;

const Header = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center mb-12"
    >
      <div className="flex items-center justify-center gap-3 mb-4">
        <div className="p-3 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl shadow-lg">
          <SafeIcon icon={FiCheckSquare} className="text-3xl text-white" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">
          TaskMaster
        </h1>
        <SafeIcon icon={FiStar} className="text-2xl text-yellow-500" />
      </div>
      <p className="text-lg text-gray-600 max-w-2xl mx-auto">
        Organize your tasks, boost productivity, and achieve your goals with our intuitive task management system.
      </p>
    </motion.div>
  );
};

export default Header;